"use client";
import { j as y } from "./jsx-runtime-CJ-St4mQ.mjs";
import * as i from "react";
import { forwardRef as I } from "react";
import { t as R } from "./tv.config-BuYIgndg.mjs";
import { u as M } from "./useBaseUiId-a-UPSsPQ.mjs";
import { u as T } from "./useRenderElement-B8V3_e8R.mjs";
import { u as g } from "./useCompositeListItem-Dxy1vBYe.mjs";
import { t as h } from "./styleHooks-CMOZRnYj.mjs";
import { u as V } from "./TabsRootContext-CBt3a0fg.mjs";
let E = /* @__PURE__ */ function(e) {
  return e.index = "data-index", e.activationDirection = "data-activation-direction", e.orientation = "data-orientation", e.hidden = "data-hidden", e;
}({});
const c = /* @__PURE__ */ i.forwardRef(function(o, n) {
  const {
    children: r,
    className: w,
    value: t,
    render: C,
    keepMounted: f = !1,
    ...p
  } = o, {
    value: b,
    getTabIdByPanelValueOrIndex: d,
    orientation: u,
    tabActivationDirection: m
  } = V(), l = M(), v = i.useMemo(() => ({
    id: l,
    value: t
  }), [l, t]), {
    ref: x,
    index: s
  } = g({
    metadata: v
  }), a = (t ?? s) !== b, N = i.useMemo(() => d(t, s), [d, s, t]), P = i.useMemo(() => ({
    hidden: a,
    orientation: u,
    tabActivationDirection: m
  }), [a, u, m]);
  return T("div", o, {
    state: P,
    ref: [n, x],
    props: [{
      "aria-labelledby": N,
      hidden: a,
      id: l ?? void 0,
      role: "tabpanel",
      tabIndex: a ? -1 : 0,
      [E.index]: s
    }, p, {
      children: a && !f ? void 0 : r
    }],
    customStyleHookMapping: h
  });
});
process.env.NODE_ENV !== "production" && (c.displayName = "TabsPanel");
const j = R({
  base: [
    "Tab__Panel",
    "relative",
    "mt-3",
    "w-full",
    "-outline-offset-1",
    "outline-blue-800",
    "focus-visible:rounded-md",
    "focus-visible:outline",
    "focus-visible:outline-2"
  ],
  variants: {}
}), k = I((e, o) => {
  const { className: n, ...r } = e;
  return /* @__PURE__ */ y.jsx(
    c,
    {
      className: j({
        className: typeof n == "string" ? n : ""
      }),
      ref: o,
      ...r
    }
  );
});
k.displayName = "TabPanel";
export {
  k as default
};
